import React, { Component } from 'react';
import { Icon, Button, Spin, Upload, message } from 'antd';
import moment from 'moment';
import request from '@/method/request';
import compute, { setKarte } from './compute';
import _ from 'lodash';
import Auth from "../../Auth";
import './index.scss';

class index extends Component {
    state = {
        date: moment().subtract(1, 'week').format('YYYY-WW'),
        dataAll: {},
        year: 1,
        value: "OCC",
        loading: true,
        uploading: false,
        fileList: [],
        kpi: {},
        lastKpi: {}
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    getData = async (date) => {
        try {
            const year = moment(date, 'YYYY-WW').format('YYYY');
            const week = moment(date, 'YYYY-WW').format('WW');
            const month = moment(date, 'YYYY-WW').format('M');
            const res = await request(`/data/groupvisualization?year=${year}&week=${week}&month=${month}`);
            this.setState({ loading: false, lastKpi: res.data.lastKpi || {}, kpi: res.data.kpi || {}, dataAll: compute(res.data || {}, week) }, () => {
                this.onChange(this.state.value, this.state.year)
            });
        } catch (error) {
            console.log(error, '数据加载错误！');
            this.setState({ loading: false });
        }
    }

    onChange = (value, year) => {
        this.setState({ value, year });
        const { date, dataAll, kpi, lastKpi } = this.state;
        const week = moment(date, 'YYYY-WW').format('WW');
        const name = {
            "OCC": 'occ',
            "ADR": 'adr',
            "RevPAR": 'revpar',
            "餐饮收入": 'fb',
        };
        let dataY = [{
            name: "酒店",
            data: (year == 1 ? dataAll.data : dataAll.last).map(x => x[name[value]])
        }, {
            name: "区域",
            data: (year == 1 ? dataAll.area : dataAll.arealast).map(x => x[name[value]])
        }, {
            name: "收入区间",
            data: (year == 1 ? dataAll.interval : dataAll.intervallast).map(x => x[name[value]])
        }];
        let _kpi = year == 1 ? kpi : lastKpi;
        dataY.push({
            name: "KPI",
            data: dataAll.data.map(x => _kpi[name[value]])
        })
        setKarte({
            title: value, year: moment(date, 'YYYY-WW').format('YYYY'),
            week,
            type: value == 'OCC' ? 'percent' : '',
            dataY
        })
    }

    render() {
        const { date, year, loading, fileList, uploading, value, dataAll: { data, last } } = this.state;
        let _data = data;
        if (value == 2) _data = last;
        const len = (_data || []).length - 1;
        const that = this;
        const props = {
            name: 'file',
            action: '/qiansheng/open/kpiImportExcel',
            accept: ".csv,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
            headers: {
                authorization: 'authorization-text',
            },
            data: {
                month: moment(date).format('M'),
                year: moment(date).format('YYYY'),
            },
            fileList,
            onChange(info) {
                that.setState({ fileList: [info.file], uploading: true });
                if (info.file.status === 'done') {
                    if (info.file.response.code == 200) {
                        message.success(`${date} 数据已经更新成功！`);
                    } else {
                        message.error(`${date} 更新失败，请重新上传或联系管理员！`);
                    }
                    that.setState({ uploading: false, });
                    return
                } else if (info.file.status === 'error') {
                    message.error(`表格上传失败！`);
                    that.setState({ uploading: false, });
                }
            },
        };

        return (

            <div className="data-Visualization">
                <div className="title">1.6 Daily Visual Diagram 日数据可视化图表 {date}
                </div>
                <Auth loading={loading} auth="edit_groupanalysisChart">
                    <Upload {...props} >
                        <Button
                            loading={uploading}
                        >
                            <Icon type="upload" /> {uploading ? '文件上传中。。。' : "上传KPI"}
                        </Button>
                    </Upload>
                </Auth>
                <Spin spinning={loading}>
                    <div className="content" style={{ marginTop: 20 }}>
                        <div className="item"
                            onClick={() => this.onChange("OCC", year)}
                            style={{ backgroundColor: _.get(_data, `${len}.occ_g`) < 0 ? "#50B07A" : "#E37646" }}
                        >
                            <span className="name">OCC</span>
                            <span className="num">{(_.get(_data, `${len}.occ`, 0) * 100).toFixed(1)}%</span>
                            <span className="data">
                                <span>较上周同时段</span>
                                <span>
                                    {(_.get(_data, `${len}.occ_g`) * 100 || 0).toFixed(1)}%
                                    {_.get(_data, `${len}.occ_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${len}.occ_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            onClick={() => this.onChange("ADR", year)}
                            style={{ backgroundColor: _.get(_data, `${len}.adr_g`) < 0 ? "#50B07A" : "#E37646" }}
                        >
                            <span className="name">ADR</span>
                            <span className="num">{(_.get(_data, `${len}.adr`, 0) * 1).toFixed(2)}</span>
                            <span className="data">
                                <span>较上周同时段</span>
                                <span>
                                    {(_.get(_data, `${len}.adr_g`) * 100 || 0).toFixed(1)}%
                                    {_.get(_data, `${len}.adr_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${len}.adr_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            style={{ backgroundColor: _.get(_data, `${len}.revpar_g`) < 0 ? "#50B07A" : "#E37646" }}
                            onClick={() => this.onChange("RevPAR", year)}>
                            <span className="name">RevPAR</span>
                            <span className="num">{(_.get(_data, `${len}.revpar`, 0) * 1).toFixed(2)}</span>
                            <span className="data">
                                <span>较上周同时段</span>
                                <span>
                                    {(_.get(_data, `${len}.revpar_g`) * 100 || 0).toFixed(1)}%
                                    {_.get(_data, `${len}.revpar_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${len}.revpar_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                        <div className="item"
                            style={{ backgroundColor: _.get(_data, `${len}.fb_g`) < 0 ? "#50B07A" : "#E37646" }}
                            onClick={() => this.onChange("餐饮收入", year)}>
                            <span className="name">餐饮收入</span>
                            <span className="num">{(_.get(_data, `${len}.fb`, 0) * 1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
                            <span className="data">
                                <span>较上周同时段</span>
                                <span>
                                    {(_.get(_data, `${len}.fb_g`) * 100 || 0).toFixed(1)}%
                                    {_.get(_data, `${len}.fb_g`) > 0 && <Icon
                                        className="up"
                                        type="arrow-up" />}
                                    {_.get(_data, `${len}.fb_g`) < 0 && <Icon
                                        className="down"
                                        type="arrow-down" />}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div className="selected">
                        <Button type={year == 1 ? 'primary' : ''}
                            onClick={() => this.onChange(value, 1)}
                        >今年</Button>
                        <Button
                            onClick={() => this.onChange(value, 2)}
                            type={year == 2 ? 'primary' : ''}>去年</Button>
                    </div>
                    <div className="chart-content">
                        <div id="chart" > </div>
                    </div>
                </Spin>
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/groupanalysisChart/index.js